import { render, staticRenderFns } from "./ScoreRankingChart.vue?vue&type=template&id=d707c86a&"
import script from "./ScoreRankingChart.vue?vue&type=script&lang=js&"
export * from "./ScoreRankingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports